export default {
  slug: 'relationships-graph',
  title: 'Relationships & graph',
  description: 'Pivot tables, investigation graph, and link types.',
  section: 'intelligence',
  order: 3,
  tags: ['graph', 'relationships', 'pivot', 'entitylink'],
  body: `# Relationships & graph

The platform is built for **clickable pivots** — every major entity exposes relationships and an investigation graph overlay.

## Relationship table

Found on case, indicator, and search detail pages under the **Relationships** tab.

| Column | Description |
|--------|-------------|
| **Relation** | Semantic link type (e.g. observed in, promoted from) |
| **Entity** | Clickable pivot link with typed badge |
| **Direction** | Inbound or outbound relative to the current entity |

Data merges **stored EntityLink rows** with **implicit links** (e.g. all IOCs on a case appear even before explicit links are created).

## Investigation graph

Open via **Graph** on case, indicator, or search detail pages.

### Controls

| Action | Result |
|--------|--------|
| Click node | Select + highlight neighbors |
| Click again | Expand graph centered on that node |
| Double-click | Open entity detail page |
| Drag canvas | Pan |
| Scroll / + − | Zoom |
| Depth 1–3 | How many hops to load |
| ← Back | Return to previous graph focus |

### Visual encoding

Node ring colors match entity types: case (cyan), indicator (amber), search (violet), persona (green), evidence (orange), actor (red).

The **focus entity** stays pinned at center with a glow.

## Link types (reference)

| Relation | Typical use |
|----------|-------------|
| \`observed_in\` | Indicator seen in a case |
| \`promoted_from\` | Indicator created from a search |
| \`operated_by\` | Persona associated with a case |
| \`enriches\` | Search or evidence enriches an indicator |
| \`related_to\` | Manual analyst association |

## API

- \`GET /api/intelligence/links?entity_type=&entity_id=\`
- \`GET /api/intelligence/graph?entity_type=&entity_id=&depth=\`

Use these endpoints when building automations or external dashboards.
`,
};
